import React from "react";
import styled from "styled-components";
import { StatusBadge } from "./prtnr";
import { formatDate } from "./utils";
import { NotificationIcon, UserIcon } from "./assets";

const statusColors = {
  Won: "rgba(18, 124, 78, 1)",
  "Verbally Committed": "rgba(244, 186, 52, 1)",
  "Proposal Sent": "rgba(244, 186, 52, 1)",
  Lost: "rgba(240, 70, 63, 1)",
  "Lead Identified": "rgba(89, 84, 222, 1)",
  "Opportunity identified": "rgba(89, 84, 222, 1)",
  Opportunity: "rgba(89, 84, 222, 1)",
  All: "rgba(100, 116, 139, 1)",
};

const getStatusColor = (action = "") => {
  const entry = Object.entries(statusColors).find(([status]) =>
    action.toLowerCase().includes(status.toLowerCase())
  );
  return entry ? entry[1] : statusColors["All"];
};

function ActivityList({ item }) {
    function formatCustomDate(oldDate) {
    const date = new Date(oldDate);
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";

    hours = hours % 12 || 12;

    return `${formattedDate} - ${hours}:${minutes}${ampm}`;
  }

  function extractChanges(changeString) {
    if (!changeString) return {};

    return changeString
      .split(";")
      .filter(Boolean)
      .reduce((acc, change) => {
        const match = change
          .trim()
          .match(/(.*?) changed from '(.*?)' to '(.*?)'/);
        if (!match) return acc;

        const [_, field, fromValue, toValue] = match;
        if (fromValue === toValue) return acc;

        const cleanField = field.replaceAll("_", " ");
        acc[cleanField] = { from: fromValue, to: toValue };
        return acc;
      }, {});
  }

  const changes = extractChanges(item.changes);
  const notesChange = changes["notes"];
  const referralStatusChange = changes["referral status"];
  const referralMemberStatusChange = changes["referral member status"];
  const lostReasonChange = changes["referral lost reason"];
  const expectedCloseDateChange = changes["expected close date"];

  // Determine which change to display (priority order)
  const primaryChange = referralStatusChange || referralMemberStatusChange;
  const hasNoteChange = notesChange && notesChange.to && notesChange.to !== 'undefined';

  return (
    <ActivitesList>
      {referralStatusChange?.to ? (
        <StatusBadge status={referralStatusChange.to} showCustomWon />
      ) : notesChange?.to ? (
        <Frame1428>
          <img src={NotificationIcon} width={20} height={20} />
        </Frame1428>
      ) : item.action === "Referral Created" ? (
        <Frame1428>
          <img src={NotificationIcon} width={20} height={20} />
        </Frame1428>
      ) : (
        <StatusBadge status={item.action} showCustomWon />
      )}

      <Frame1435>
        <Frame5>
         <Frame1519>
            {item?.action === "Referral Created" ? (
              <Frame1437>
                <StatusChangedTo>
                  <strong>Referral Created</strong> by {item?.updated_by_name || "Unknown"}
                </StatusChangedTo>
              </Frame1437>
            ) : (
              <>
                {primaryChange?.to && (
                  <Frame1437>
                    <StatusChangedTo>
                      <strong>Status Changed to:</strong>{" "}
                      <span style={{ color: getStatusColor(primaryChange.to) }}>
                        {primaryChange.to}
                      </span>
                      <strong> by </strong>
                      {item?.updated_by_name || "Unknown"}
                    </StatusChangedTo>
                  </Frame1437>
                )}

                {lostReasonChange?.to && lostReasonChange.to !== 'undefined' && (
                  <Frame1437>
                    <StatusChangedTo>
                      <strong>Lost Reason:</strong> {lostReasonChange.to}
                    </StatusChangedTo>
                  </Frame1437>
                )}

                {hasNoteChange && (
                  <Frame1437>
                    <StatusChangedTo>
                      <strong>Note Added:</strong> {notesChange.to}
                      <strong> by </strong>
                      {item?.updated_by_name || "Unknown"}
                    </StatusChangedTo>
                  </Frame1437>
                )}

                {expectedCloseDateChange?.to && expectedCloseDateChange.to !== 'undefined' && (
                  <Frame1437>
                    <StatusChangedTo>
                      <strong>Expected Close Date:</strong> {new Date(expectedCloseDateChange.to).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                    </StatusChangedTo>
                  </Frame1437>
                )}
              </>
            )}
          </Frame1519>
          <_1Apr2025_0001>{formatCustomDate(item?.updated_at)}</_1Apr2025_0001>
        </Frame5>
      </Frame1435>
    </ActivitesList>
  );
}

export default ActivityList;

const Frame1428 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 48px;
  min-height: 48px;
  border-radius: 999px;
  background: rgba(89, 84, 222, 0.1);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ActivitesList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border-bottom: solid 1px rgba(136, 136, 136, 0.1);
  max-width: 1152px;
  width: 100%;
  box-sizing: border-box;
  padding: 0px 0px 16px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1428_0001 = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const Frame1435 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 1112px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1519 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  box-sizing: border-box;
  flex-wrap: wrap;
  word-break: break-word;
  width: 70%;
  overflow: hidden;
`;

const StatusChangedTo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LeadIdentified_0001 = styled.span`
  color: rgb(89, 84, 222);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  word-break: break-word;
`;

const _1Apr2025_0001 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;
const Frame1437 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-wrap: wrap;
  flex: 1;
`;

const Note = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 1065px;
  flex: 1;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: linear-gradient(90deg, rgb(136, 203, 234), rgb(95, 95, 196));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 32px;
  width: 588px;
  box-sizing: border-box;
  padding-right: 16px;
`;

const Logo_0001 = styled.div`
  width: 232px;
  height: 34px;
  position: relative;
`;

const Logo1_0001 = styled.div`
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
  right: -1px;
  bottom: 0px;
`;

const Vector_0009 = styled.svg`
  width: 23px;
  height: 28px;
  position: absolute;
  left: 47px;
  top: 3px;
  right: 163px;
  bottom: 3px;
`;

const Vector_0010 = styled.svg`
  width: 23px;
  height: 22px;
  position: absolute;
  left: 73px;
  top: 9px;
  right: 137px;
  bottom: 3px;
`;

const Vector_0011 = styled.svg`
  width: 23px;
  height: 22px;
  position: absolute;
  left: 99px;
  top: 9px;
  right: 111px;
  bottom: 3px;
`;

const Vector_0012 = styled.svg`
  width: 14px;
  height: 22px;
  position: absolute;
  left: 127px;
  top: 9px;
  right: 92px;
  bottom: 3px;
`;

const Vector_0013 = styled.svg`
  width: 15px;
  height: 28px;
  position: absolute;
  left: 142px;
  top: 3px;
  right: 76px;
  bottom: 3px;
`;

const Vector_0014 = styled.svg`
  width: 21px;
  height: 22px;
  position: absolute;
  left: 160px;
  top: 9px;
  right: 52px;
  bottom: 3px;
`;

const Vector_0015 = styled.svg`
  width: 22px;
  height: 22px;
  position: absolute;
  left: 184px;
  top: 9px;
  right: 27px;
  bottom: 3px;
`;

const Vector_0016 = styled.svg`
  width: 14px;
  height: 22px;
  position: absolute;
  left: 210px;
  top: 9px;
  right: 10px;
  bottom: 3px;
`;

const Vector_0017 = styled.svg`
  width: 6px;
  height: 6px;
  position: absolute;
  left: 226px;
  top: 9px;
  right: 1px;
  bottom: 19px;
`;

const Vector_0018 = styled.svg`
  width: 33px;
  height: 20px;
  position: absolute;
  left: 1px;
  top: 14px;
  right: 199px;
  bottom: 0px;
`;

const Vector_0019 = styled.svg`
  width: 10px;
  height: 10px;
  position: absolute;
  left: 13px;
  top: 0px;
  right: 210px;
  bottom: 24px;
`;

const Vector_0020 = styled.svg`
  width: 35px;
  height: 23px;
  position: absolute;
  left: 0px;
  top: 1px;
  right: 198px;
  bottom: 10px;
`;

const PaartnerLimitedRegisteredInEnglandNo16078386 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
`;

const VatRegistration3700001111 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
`;

const RegisteredOfficeUnit15RunwellHallFarmhouseHoeLaneRettendonEssexEnglandCm38Dq = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Right_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 588px;
  box-sizing: border-box;
`;

const MenuList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 221px;
  box-sizing: border-box;
`;

const Legal = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TermsConditions = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const PrivacyPolicy = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const CookiePolicy = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const ModernSlaveryStatement = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const MenuList_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 221px;
  box-sizing: border-box;
`;

const TermsConditions_0001 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const MenuList_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  box-sizing: border-box;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
`;
